export const MeteoriteElementAttributes = {
    DEBUG_INFO: "DebugInfo",
    DEBUG: "Debug",
    RATE: "Rate",
    START: "Start",
    STOP: "Stop",
    START_POSITION: "StartPosition",
    END_POSITION: "EndPosition",
    STYLE: "Style",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/CustomComponentAttributes.ts
 **/